import React from 'react';

import { useSelector } from 'react-redux';
import QuoterStepList from './QuoterStepList';

const QuoterProgress = () => {
  const previousSteps = 3;
  const totalSteps = useSelector((state) => state.appConfig.quoterTotalSteps) - previousSteps;
  const quoterCurrentStep = useSelector((state) => state.appConfig.quoterCurrentStep) - previousSteps;

  return (
    <div id="quoter-progress" className="quoter-progress">
      {
        quoterCurrentStep <= totalSteps
          ? (
            <QuoterStepList
              currentStep={quoterCurrentStep}
              totalSteps={totalSteps} />
          )
          : ''
      }
    </div>

  );
};

export default QuoterProgress;
